import $ from "jquery";
import RangeSlider from "./RangeSlider";
class FiltersRangeSliders {
  static init() {
    const $rangeSliders = $(".js-range-slider");
    console.log("uruchamianie slider\xF3w12");
    $rangeSliders.each((i, el) => {
      console.log("uruchamianie slider\xF3w");
      const slider = new RangeSlider(el);
    });
  }
}
export default FiltersRangeSliders;
